import { useCallback } from 'react'
import { useMutation } from 'urql'

import {
  CompleteProfileMutation,
  CompleteProfileMutationVariables,
} from '@app/generated/graphql'
import { COMPLETE_PROFILE_MUTATION } from '@app/modules/sso/queries/complete-profile'

import { SSOCognitoIdentity } from './useResolveSSOProfile'

/**
 * Creates a minimal profile for a brand-new SSO identity, deferring full
 * registration (org/phone/dob/jobTitle/T&Cs) until after the user has
 * acted on whatever deep link brought them in (e.g. an invite).
 */
export const useCreateStubProfile = () => {
  const [state, completeProfile] = useMutation<
    CompleteProfileMutation,
    CompleteProfileMutationVariables
  >(COMPLETE_PROFILE_MUTATION)

  const createStubProfile = useCallback(
    (identity: SSOCognitoIdentity) => {
      const input: CompleteProfileMutationVariables['input'] = {
        id: identity.id,
        givenName: identity.givenName,
        familyName: identity.familyName,
        email: identity.email,
        ssoCognitoUserId: identity.id,
        isStub: true,
      }

      return completeProfile({ input })
    },
    [completeProfile],
  )

  return [state, createStubProfile] as const
}
